import type { ReactNode } from 'react';
import { cardStyle, labelStyle, colors } from './styles';

interface EmptyStateProps {
  title: string;
  description: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div style={{ ...cardStyle, padding: '32px', textAlign: 'center' }}>
      <div style={{ ...labelStyle, marginBottom: '8px' }}>{title}</div>
      <p style={{ fontSize: '0.85rem', color: colors.muted, lineHeight: 1.6, maxWidth: '480px', margin: '0 auto' }}>
        {description}
      </p>
      {action && <div style={{ marginTop: '16px' }}>{action}</div>}
    </div>
  );
}
